import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  send_actions_button: { id: 'towingRecord.sendActions.button', defaultMessage: 'Lähetä' },
  send_actions_waybill: { id: 'towingRecord.sendActions.waybill', defaultMessage: 'Kuormakirja' },
  send_document_validation_email_required: {
    id: 'towingRecord.sendDocument.validation.emailRequired',
    defaultMessage: 'Sähköpostiosoite vaaditaan',
  },
  send_document_validation_email_invalid: {
    id: 'towingRecord.sendDocument.validation.emailInvalid',
    defaultMessage: 'Virheellinen sähköpostiosoite',
  },
  send_document_validation_phone_required: {
    id: 'towingRecord.sendDocument.validation.phoneRequired',
    defaultMessage: 'Puhelinnumero vaaditaan',
  },
  send_document_validation_phone_invalid: {
    id: 'towingRecord.sendDocument.validation.phoneInvalid',
    defaultMessage: 'Virheellinen puhelinnumero',
  },
  send_document_success_title: {
    id: 'towingRecord.sendDocument.success.title',
    defaultMessage: 'Lähetys onnistui',
  },
  send_document_success_message: {
    id: 'towingRecord.sendDocument.success.message',
    defaultMessage: 'Kuormakirjan linkki lähetetty onnistuneesti',
  },
  send_document_error_title: {
    id: 'towingRecord.sendDocument.error.title',
    defaultMessage: 'Virhe',
  },
  send_document_error_message: {
    id: 'towingRecord.sendDocument.error.message',
    defaultMessage: 'Kuormakirjan lähettäminen epäonnistui',
  },
  send_document_error_message_fallback: {
    id: 'towingRecord.sendDocument.error.messageFallback',
    defaultMessage: 'Virhe kuormakirjaa lähettäessä',
  },
  send_document_header: {
    id: 'towingRecord.sendDocument.header',
    defaultMessage: 'Lähetä kuormakirja',
  },
  send_document_import_label: {
    id: 'towingRecord.sendDocument.importLabel',
    defaultMessage: 'Tuo kuormakirjan tiedoista',
  },
  send_document_select_placeholder: {
    id: 'towingRecord.sendDocument.selectPlaceholder',
    defaultMessage: 'Valitse',
  },
  send_document_method_heading: {
    id: 'towingRecord.sendDocument.methodHeading',
    defaultMessage: 'Lähetystapa',
  },
  send_document_email_button: {
    id: 'towingRecord.sendDocument.emailButton',
    defaultMessage: 'Sähköposti',
  },
  send_document_sms_button: {
    id: 'towingRecord.sendDocument.smsButton',
    defaultMessage: 'Tekstiviesti',
  },
  send_document_email_label: {
    id: 'towingRecord.sendDocument.emailLabel',
    defaultMessage: 'Sähköpostiosoite',
  },
  send_document_phone_label: {
    id: 'towingRecord.sendDocument.phoneLabel',
    defaultMessage: 'Puhelinnumero',
  },
  send_document_submit_button: {
    id: 'towingRecord.sendDocument.submitButton',
    defaultMessage: 'Lähetä',
  },
  send_document_cancel_button: {
    id: 'towingRecord.sendDocument.cancelButton',
    defaultMessage: 'Peruuta',
  },
  send_document_option_orderer_email: {
    id: 'towingRecord.sendDocument.option.ordererEmail',
    defaultMessage: 'Tilaajan sähköposti: {email}',
  },
  send_document_option_orderer_phone: {
    id: 'towingRecord.sendDocument.option.ordererPhone',
    defaultMessage: 'Tilaajan puhelinnumero: {phone}',
  },
  send_document_option_signator_email: {
    id: 'towingRecord.sendDocument.option.signatorEmail',
    defaultMessage: 'Allekirjoittajan sähköposti: {email}',
  },
  send_document_option_signator_phone: {
    id: 'towingRecord.sendDocument.option.signatorPhone',
    defaultMessage: 'Allekirjoittajan puhelinnumero: {phone}',
  },
  order_cancelled_title: {
    id: 'towingRecord.view.orderCancelled.title',
    defaultMessage: 'Tilaus peruttu',
  },
  order_cancelled_message: {
    id: 'towingRecord.view.orderCancelled.message',
    defaultMessage: 'Tilaus on peruttu. Lopeta työ.',
  },
  locked_title: {
    id: 'towingRecord.view.locked.title',
    defaultMessage: 'Tilaus lukittu',
  },
  locked_message_editable: {
    id: 'towingRecord.view.locked.messageEditable',
    defaultMessage:
      '{lockedByUser} on avannut työn muokattavaksi. Tallentamattomat muutokset voivat hävitä ellei niitä tallenna heti.',
  },
  locked_message_view: {
    id: 'towingRecord.view.locked.messageView',
    defaultMessage: '{lockedByUser} on avannut työn muokattavaksi.',
  },
})
